import { useCurrentUser } from './use-current-user';

/**
 * Per-user Bizy visibility — answers "should we render Bizy for this user right now?".
 *
 * Backed by `user.bizy_visible` on the user blueprint. The backend cascades
 * billing entitlement and the per-role `bizy_for_admins` / `bizy_for_employees`
 * FeatureToggle states into a single per-user boolean.
 *
 * For the company-scope "is this company in the Bizy program?" question, use
 * `useIsBizyEnabledForCompany` instead.
 */
export function useIsBizyEnabledForUser(): boolean {
	return useCurrentUser()?.bizy_visible ?? false;
}
